import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "num",
  "use": "num-usage",
  "viewBox": "0 0 10 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 11\" id=\"num\"><path fill=\"#7E8FA5\" d=\"M5.424 11h-1.52l.928-2.704h-1.52L2.4 11H.896l.912-2.704H.272L.688 7h1.568l.864-2.656H1.552l.4-1.28h1.616L4.464.328h1.504l-.896 2.736h1.504L7.472.328h1.52l-.928 2.736h1.552l-.384 1.28h-1.6L6.752 7h1.616l-.4 1.296H6.32zm-.176-4 .88-2.656H4.624L3.76 7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol